/* Header: measure the sticky row height (so the homepage hero can slide under
   it) and solidify the transparent overlay once the page is scrolled. */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  function setRowHeight() {
    document.documentElement.style.setProperty('--row-h', header.offsetHeight + 'px');
  }

  function onScroll() {
    header.classList.toggle('is-solid', window.scrollY > 20);
  }

  setRowHeight();
  onScroll();
  window.addEventListener('resize', setRowHeight, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
})();
